import { defineComponent as _defineComponent } from 'vue'
import { UIKitProvider } from '@tencentcloud/uikit-base-component-vue2';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return { __sfc: true,UIKitProvider }
}

})